export default __webpack_public_path__ + "b1d694f660569a9a9ee6d1236227eaff.ttf";